const messages = {
  title: "Oups ! Pourquoi êtes-vous ici ?",
  description:
    "Nous sommes désolés pour le désagrément. Il semble que vous tentiez d'accéder à une page qui a été supprimée ou qui n'a jamais existé.",
  backHomeButton: "Retour au tableau de bord",
}

export default {
  messages
}
